'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mediaConstants = require('../../../../common/media/mediaConstants');

var _ElementImage = require('../../../components/images/ElementImage');

var _ElementImage2 = _interopRequireDefault(_ElementImage);

require('./BoardImage.scss');

var _gridUtils = require('../../../utils/grid/gridUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Styles


// Components
// Lib
var getStyle = function getStyle(size) {
    return {
        width: size,
        height: size
    };
};

var BoardImage = function BoardImage(_ref) {
    var element = _ref.element,
        size = _ref.size,
        gridSize = _ref.gridSize;

    if (!element) return null;

    var actualSize = (0, _gridUtils.gridPointsToPixels)(size, gridSize);

    return _react2.default.createElement(
        'div',
        { className: 'BoardImage', style: getStyle(actualSize) },
        _react2.default.createElement(_ElementImage2.default, {
            imageType: _mediaConstants.IMAGE_TYPES.BOARD,
            element: element,
            size: actualSize,
            forcedHeight: actualSize,
            forcedWidth: actualSize })
    );
};

BoardImage.propTypes = {
    element: _propTypes2.default.object,
    imageData: _propTypes2.default.object,
    attachmentData: _propTypes2.default.object,
    size: _propTypes2.default.number,
    gridSize: _propTypes2.default.number
};

exports.default = BoardImage;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/board/boardIcon/BoardImage.js
// module id = 721
// module chunks = 0